import { useRef, useState } from 'react';

import { Box, Typography, MenuList } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { MIconButton } from '../../../../@material-extend';
import MenuPopover from '../../../../organisms/MenuPopover';
import MyAvatar from '../MyAvatar';
import AvatarMenuItems from './AvatarMenuItems';
import { OnTimeMenuModals, OnTimeMenuContent } from './OnTimeMenuItems';

import useAuth from '../../../../../hooks/useAuth';

const AvatarButton = () => {
  const anchorRef = useRef(null);
  const onTimeRef = useRef(null);
  const { user } = useAuth();

  const [openMenu, setOpenMenu] = useState(false);
  // En cas de déconnexion manuelle ou automatique, on s'arrête ici pour éviter les erreurs de console et de cycle de vie
  if (!user) {
    return null;
  }

  // Si on se connecte, on déstructure les infos de l'utilisateur
  const { email, firstname, lastname } = user;
  const userFullName = `${firstname} ${firstname !== lastname ? lastname : ''}`;
  const isOnTime = !!window.env.isClockingApp;

  const handleOpen = () => {
    setOpenMenu(true);
  };

  const handleClose = () => {
    setOpenMenu(false);
  };

  return (
    <>
      <MIconButton id="user-avatar-button" ref={anchorRef} sx={styleIconButton(openMenu)} onClick={handleOpen}>
        <MyAvatar />
      </MIconButton>

      {/* Modales OnTime — toujours montées pour survivre à la fermeture du popover */}
      {isOnTime && <OnTimeMenuModals ref={onTimeRef} />}

      {openMenu && (
        <MenuPopover
          id="user-avatar-menu"
          anchorEl={anchorRef.current}
          sx={{ width: 320 }}
          open={openMenu}
          onClose={handleClose}
        >
          <MenuList sx={styleMenu}>
            <Box sx={{ my: 1.5, px: 2.5 }}>
              <Typography variant="subtitle1">{userFullName}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {email}
              </Typography>
            </Box>

            {isOnTime ? (
              <OnTimeMenuContent onTimeRef={onTimeRef} handleClose={handleClose} />
            ) : (
              <AvatarMenuItems handleClose={handleClose} />
            )}
          </MenuList>
        </MenuPopover>
      )}
    </>
  );
};

const styleMenu = {
  '.material-symbols-outlined': {
    fontSize: '1.25rem'
  },
  '.MuiDivider-root': {
    my: 1
  }
};

const styleIconButton = (openMenu) => ({
  height: 44,
  width: 44,
  padding: 0,
  ...(openMenu && {
    '&:before': {
      content: "''",
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: '50%',
      bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
      zIndex: 1
    }
  })
});

export default AvatarButton;
